/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publishlisting1Inputs */

const en_publishlisting1 = /** @type {(inputs: Publishlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Listing`)
};

const de_publishlisting1 = /** @type {(inputs: Publishlisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish Listing" |
*
* @param {Publishlisting1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const publishlisting1 = /** @type {((inputs?: Publishlisting1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishlisting1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_publishlisting1(inputs)
	return de_publishlisting1(inputs)
});
export { publishlisting1 as "publishListing" }